const config = {
  baseAPI: 'https://customer-service-api.kongsalak.dev',
  apiGatewayUrl: 'https://user-api-gateway.kongsalak.dev',
  redirectUrl: 'https://xn--m3ca1athe9asc7b2b6iqe.com',
  liffId: '1660835514-NbkZX28M',
  cookieDomain: '.xn--m3ca1athe9asc7b2b6iqe.com',
};

export default config;
